export const GIT_COMMIT_HASH = "88a824e6"
